<app-progress-indicator *ngIf="(isLoading$ | async)" />
<app-users-list *ngIf="(isLoading$ | async) === false" [list]="active$ | async" [status]="true" [createNew]="true" />
<app-users-list *ngIf="(isLoading$ | async) === false" [list]="inactive$ | async" [status]="false" />
